module.exports = __webpack_public_path__ + "static/media/profile-mike-isom.a51787d3.jpg";